export default __webpack_public_path__ + "static/media/pewLogo.5ecb3c90.png";